import paper from '@turbowarp/paper';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import bindAll from 'lodash.bindall';
import Modes from '../lib/modes';

import { clearFillGradient } from '../reducers/fill-style';
import { changeMode } from '../reducers/modes';
import { clearSelectedItems, setSelectedItems } from '../reducers/selected-items';
import { setCursor } from '../reducers/cursor';

import { getSelectedLeafItems } from '../helper/selection';
import BitSelectTool from '../helper/bit-tools/select-tool';
import SelectModeComponent from '../components/bit-select-mode/bit-select-mode.jsx';

class BitSelectMode extends React.Component {
  constructor(props) {
    super(props);
    bindAll(this, ['activateTool', 'deactivateTool']);
  }
  componentDidMount() {
    if (this.props.isSelectModeActive) {
      this.activateTool(this.props);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.tool && nextProps.selectedItems !== this.props.selectedItems) {
      this.tool.onSelectionChanged(nextProps.selectedItems);
    }

    if (nextProps.isSelectModeActive && !this.props.isSelectModeActive) {
      this.activateTool();
    } else if (!nextProps.isSelectModeActive && this.props.isSelectModeActive) {
      this.deactivateTool();
    }
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.isSelectModeActive !== this.props.isSelectModeActive;
  }
  componentWillUnmount() {
    if (this.tool) {
      this.deactivateTool();
    }
  }
  activateTool() {
    this.props.clearGradient();
    this.tool = new BitSelectTool(
      this.props.setSelectedItems,
      this.props.clearSelectedItems,
      this.props.setCursor,
      this.props.onUpdateImage
    );
    this.tool.activate();
  }
  deactivateTool() {
    this.tool.deactivateTool();
    this.tool.remove();
    this.tool = null;
  }
  render() {
    return <SelectModeComponent isSelected={this.props.isSelectModeActive} onMouseDown={this.props.handleMouseDown} />;
  }
}

BitSelectMode.propTypes = {
  clearGradient: PropTypes.func.isRequired,
  clearSelectedItems: PropTypes.func.isRequired,
  handleMouseDown: PropTypes.func.isRequired,
  isSelectModeActive: PropTypes.bool.isRequired,
  onUpdateImage: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.instanceOf(paper.Item)),
  setCursor: PropTypes.func.isRequired,
  setSelectedItems: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isSelectModeActive: state.scratchPaint.mode === Modes.BIT_SELECT,
  selectedItems: state.scratchPaint.selectedItems
});
const mapDispatchToProps = (dispatch) => ({
  clearGradient: () => {
    dispatch(clearFillGradient());
  },
  clearSelectedItems: () => {
    dispatch(clearSelectedItems());
  },
  setCursor: (cursorType) => {
    dispatch(setCursor(cursorType));
  },
  setSelectedItems: () => {
    dispatch(setSelectedItems(getSelectedLeafItems()));
  },
  handleMouseDown: () => {
    dispatch(changeMode(Modes.BIT_SELECT));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BitSelectMode);
